import React from "react";
import { Line, LineChart, ResponsiveContainer, YAxis } from "recharts";
import { useIsXXLMediaQuery } from "@app/hooks";
import { ChartData } from "../../types";

type Props = {
  series: ChartData[];
};

export const Chart: React.FC<Props> = ({ series }) => {
  const isXXLScreen = useIsXXLMediaQuery();

  return (
    <ResponsiveContainer height={isXXLScreen ? 315 : 200} width="100%">
      <LineChart width={500} height={isXXLScreen ? 315 : 200} data={series}>
        <YAxis
          orientation="left"
          axisLine={false}
          width={30}
          domain={["dataMin", "dataMax"]}
          type="number"
          includeHidden
          tickCount={11}
          tickFormatter={(tick) => Math.round(Number(tick)).toString()}
          stroke="#999999"
          interval={"preserveStartEnd"}
          tickLine={false}
          scale={"auto"}
        />
        <Line
          type="monotone"
          dataKey="alpian"
          stroke="#FFFFFF"
          strokeWidth={2}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="morningstarMarkets"
          stroke="#663F83"
          strokeWidth={2}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="morningstarCore"
          stroke="#2B4387"
          strokeWidth={2}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
